export default __webpack_public_path__ + "static/media/right.ca83a801.svg";